// import React, { useState } from "react";
// import {
//   Box,
//   Tabs,
//   Tab,
//   Typography,
//   Avatar,
//   Badge,
//   Divider,
//   IconButton,
// } from "@mui/material";
// import PushPinOutlinedIcon from "@mui/icons-material/PushPinOutlined";
// import DoneAllIcon from "@mui/icons-material/DoneAll";

// const messages = [
//   {
//     id: 1,
//     name: "Harry Maguire",
//     message: "You need to improve now",
//     time: "09:12 AM",
//     pinned: true,
//     read: true,
//     online: true,
//     unreadCount: 0,
//   },
//   {
//     id: 2,
//     name: "Rasmus Højlund",
//     message: "Bos, I need to talk today",
//     time: "03:11 AM",
//     pinned: false,
//     read: false,
//     online: false,
//     unreadCount: 2,
//   },
//   {
//     id: 3,
//     name: "Rasmus Maguire",
//     message: "Rashford is typing...",
//     time: "09:12 AM",
//     pinned: false,
//     read: false,
//     online: true,
//     unreadCount: 2,
//     typing: true,
//   },
// ];

// const ChatList = () => {
//   const [tab, setTab] = useState(0);

//   const handleChange = (_, newValue) => {
//     setTab(newValue);
//   };

//   return (
//     <Box
//       sx={{
//         width: 320,
//         bgcolor: "#fff",
//         borderRadius: 3,
//         boxShadow: "0px 2px 8px rgba(0,0,0,0.05)",
//         p: 2,
//       }}
//     >
//       {/* Tabs */}
//       {/* <Tabs
//         value={tab}
//         onChange={handleChange}
//         variant="fullWidth"
//         sx={{
//           mb: 2,
//           "& .MuiTab-root": { textTransform: "none", fontSize: 14, color: "gray" },
//           "& .Mui-selected": { color: "#000", fontWeight: 600 },
//           "& .MuiTabs-indicator": { backgroundColor: "#000" },
//         }}
//       >
//         <Tab label="All" />
//         <Tab label="Personal" />
//         <Tab label="Groups" />
//       </Tabs> */}
//       <Tabs
//   value={tab}
//   onChange={handleChange}
//   variant="fullWidth"
//   sx={{
//     backgroundColor: '#f1f1f1', // background container color
//     borderRadius: '999px',      // make the tab bar pill-shaped
//     minHeight: 60,
//     alignItems: "center",
//     "& .MuiTabs-flexContainer": {
//       position: 'relative',
//       zIndex: 1
//     },
//     "& .MuiTabs-indicator": {
//       display: 'none', // Hide default underline
//     },
//   }}
// >
//   {['All', 'Personal', 'Groups'].map((label, index) => (
//     <Tab
//       key={label}
//       label={label}
//       sx={{
//         textTransform: 'none',
//         fontSize: 14,
//         color: tab === index ? '#000' : 'gray',
//         fontWeight: tab === index ? 600 : 400,
//         backgroundColor: tab === index ? '#fff' : 'transparent',
//         borderRadius: '999px',
//         minHeight: 18,
//         textAlign: "center",
//         zIndex: 2,
//         mx: 0.1, // space between tabs
//       }}
//     />
//   ))}
// </Tabs>

//       {/* Pinned Section */}
//       <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
//         <Typography variant="body2" color="text.secondary">
//           Pinned Message
//         </Typography>
//         <PushPinOutlinedIcon sx={{ fontSize: 16, color: "gray" }} />
//       </Box>

//       {/* Messages */}
//       {messages.map((msg, index) => (
//         <Box key={msg.id}>
//           <Box
//             display="flex"
//             alignItems="center"
//             justifyContent="space-between"
//             py={1.2}
//             sx={{
//               cursor: "pointer",
//               "&:hover": { bgcolor: "#f9f9f9" },
//             }}
//           >
//             {/* Left: Avatar + Info */}
//             <Box display="flex" alignItems="center" gap={1.5}>
//               <Badge
//                 overlap="circular"
//                 anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
//                 variant="dot"
//                 invisible={!msg.online}
//                 sx={{
//                   "& .MuiBadge-dot": {
//                     backgroundColor: "#22C55E",
//                     border: "2px solid white",
//                   },
//                 }}
//               >
//                 <Avatar sx={{ bgcolor: msg.typing ? "#FBBF24" : "#E5E7EB" }}>
//                   {msg.name.charAt(0)}
//                 </Avatar>
//               </Badge>
//               <Box>
//                 <Typography sx={{ fontSize: 14, fontWeight: 600 }}>
//                   {msg.name}
//                 </Typography>
//                 <Typography
//                   sx={{
//                     fontSize: 12,
//                     color: msg.typing ? "#22C55E" : "gray",
//                     fontStyle: msg.typing ? "italic" : "normal",
//                   }}
//                 >
//                   {msg.message}
//                 </Typography>
//               </Box>
//             </Box>

//             {/* Right: Time + Status */}
//             <Box textAlign="right">
//               <Typography sx={{ fontSize: 11, color: "gray" }}>
//                 {msg.time}
//               </Typography>
//               {msg.read ? (
//                 <DoneAllIcon sx={{ fontSize: 14, color: "#3B82F6" }} />
//               ) : msg.unreadCount > 0 ? (
//                 <Badge
//                   badgeContent={msg.unreadCount}
//                   color="error"
//                   sx={{
//                     "& .MuiBadge-badge": {
//                       fontSize: 10,
//                       minWidth: 16,
//                       height: 16,
//                     },
//                   }}
//                 />
//               ) : null}
//             </Box>
//           </Box>
//           {index < messages.length - 1 && <Divider />}
//         </Box>
//       ))}
//     </Box>
//   );
// };

// export default ChatList;
import React, { useEffect, useState } from "react";
import {
  Box,
  Tabs,
  Tab,
  Typography,
  Avatar,
  Badge,
  Divider,
} from "@mui/material";
import PushPinOutlinedIcon from "@mui/icons-material/PushPinOutlined";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import { useDispatch, useSelector } from "react-redux";
import { addPost } from "app/redux/slice/postSlice";
import { useNavigate } from "react-router-dom";
import { GroupChatGet, PersonalChatList } from "app/redux/slice/getSlice";

const ChatList = ({ enableNavigation = false }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [tab, setTab] = useState(0);
  console.log("🚀 ~ ChatList ~ tab:", tab)

  // 🔥 REAL DATA FROM REDUX
  const personalChats =
    useSelector((state) => state.getSlice.getPersonalChatListData);

  const groupChats =
    useSelector((state) => state.getSlice.getGroupChatData);
  useEffect(() => {
    dispatch(PersonalChatList());
    dispatch(GroupChatGet());
  }, [dispatch]);

  // 🔥 TAB FILTER
  const chats =
    tab === 0
      ? [...personalChats, ...groupChats]
      : tab === 1
      ? personalChats
      : groupChats;

  const handleSelect = (chat) => {
    dispatch(addPost(chat));

    if (enableNavigation) {
      navigate("/home/message"); 
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        bgcolor: "#fff",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* ===== TABS ===== */}
      <Tabs
        value={tab}
        onChange={(_, v) => setTab(v)}
        variant="fullWidth"
        sx={{
          backgroundColor: "#f1f1f1",
          borderRadius: "999px",
          mx: 1,
          mt: 1,
          "& .MuiTabs-indicator": { display: "none" },
        }}
      >
        {["All", "Personal", "Groups"].map((label, index) => (
          <Tab
            key={label}
            label={label}
            sx={{
              textTransform: "none",
              fontSize: 14,
              fontWeight: tab === index ? 600 : 400,
              backgroundColor: tab === index ? "#fff" : "transparent",
              borderRadius: "999px",
            }}
          />
        ))}
      </Tabs>

      {/* ===== PINNED HEADER ===== */}
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        px={2}
        mt={2}
      >
        <Typography variant="body2" color="text.secondary">
          Pinned Message
        </Typography>
        <PushPinOutlinedIcon sx={{ fontSize: 16, color: "gray" }} />
      </Box>

      {/* ===== CHAT LIST (SCROLLABLE) ===== */}
      <Box sx={{ flex: 1, overflowY: "auto", px: 1 }}>
        {chats.map((chat, index) => (
          <>
          {tab === 2 ? (
          <Box key={chat.GroupID}>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              py={1.2}
              px={1}
              sx={{
                cursor: "pointer",
                borderRadius: 1,
                "&:hover": { bgcolor: "#f9f9f9" },
              }}
              onClick={() => handleSelect(chat)}
            >
              {/* LEFT */}
              <Box display="flex" alignItems="center" gap={1.5}>
                <Badge
                  overlap="circular"
                  variant="dot"
                  invisible={!chat.Status}
                  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  sx={{
                    "& .MuiBadge-dot": {
                      bgcolor: "#22C55E",
                      border: "2px solid white",
                    },
                  }}
                >
                  <Avatar src={chat.ProfileImage || chat.GroupProfileImage}>
                    {chat.GroupName}
                  </Avatar>
                </Badge>

                <Box>
                  <Typography sx={{ fontSize: 14, fontWeight: 600 }}>
                    {chat.GroupName}
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: 12,
                      color: "gray",
                    }}
                    noWrap
                  >
                    {chat.LastMessage || "Media"}
                  </Typography>
                </Box>
              </Box>

              {/* RIGHT */}
              <Box textAlign="right">
                <Typography sx={{ fontSize: 11, color: "gray" }}>
                  {chat.LastMessageTime}
                </Typography>

                {chat.UnreadCount > 0 ? (
                  <Badge
                    badgeContent={chat.UnreadCount}
                    color="error"
                    sx={{
                      "& .MuiBadge-badge": {
                        fontSize: 10,
                        minWidth: 16,
                        height: 16,
                      },
                    }}
                  />
                ) : (
                  <DoneAllIcon sx={{ fontSize: 14, color: "#3B82F6" }} />
                )}
              </Box>
            </Box>

            {index < chats.length - 1 && <Divider />}
          </Box>
          ):(
           <Box key={chat.UserID || chat.GroupID}>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              py={1.2}
              px={1}
              sx={{
                cursor: "pointer",
                borderRadius: 1,
                "&:hover": { bgcolor: "#f9f9f9" },
              }}
              onClick={() => handleSelect(chat)}
            >
              {/* LEFT */}
              <Box display="flex" alignItems="center" gap={1.5}>
                <Badge
                  overlap="circular"
                  variant="dot"
                  invisible={!chat.OnlineStatus}
                  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  sx={{
                    "& .MuiBadge-dot": {
                      bgcolor: "#22C55E",
                      border: "2px solid white",
                    },
                  }}
                >
                  <Avatar src={chat.GroupProfileImage ? chat.GroupProfileImage :chat.ProfileImage}>
                    {chat.GroupName ? chat.GroupName :chat.UserName}
                  </Avatar>
                </Badge>

                <Box>
                  <Typography sx={{ fontSize: 14, fontWeight: 600 }}>
{chat.GroupName ? chat.GroupName :chat.UserName}                  </Typography>

                  <Typography
                    sx={{
                      fontSize: 12,
                      color: "gray",
                    }}
                    noWrap
                  >
                    {chat.latestMessage || "Media"}
                  </Typography>
                </Box>
              </Box>

              {/* RIGHT */}
              <Box textAlign="right">
                <Typography sx={{ fontSize: 11, color: "gray" }}>
                  {chat.LastMessageTime}
                </Typography>

                {chat.UnreadCount > 0 ? (
                  <Badge
                    badgeContent={chat.UnreadCount}
                    color="error"
                    sx={{
                      "& .MuiBadge-badge": {
                        fontSize: 10,
                        minWidth: 16,
                        height: 16,
                      },
                    }}
                  />
                ) : (
                  <DoneAllIcon sx={{ fontSize: 14, color: "#3B82F6" }} />
                )}
              </Box>
            </Box>

            {index < chats.length - 1 && <Divider />}
          </Box>  
          )}
          </>
        ))}
      </Box>
    </Box>
  );
};

export default ChatList;
